import { render, staticRenderFns } from "./NoAuthority.vue?vue&type=template&id=0a6b4866&scoped=true&"
import script from "./NoAuthority.vue?vue&type=script&lang=js&"
export * from "./NoAuthority.vue?vue&type=script&lang=js&"
import style0 from "./NoAuthority.vue?vue&type=style&index=0&id=0a6b4866&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6b4866",
  null
  
)

export default component.exports